"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import { GRID_CLASSES } from "@/libs/grid/grid";

import "swiper/css";
import "swiper/css/effect-fade";

const SLIDES = [
    {
        desktop: "/images/generators-banner.jpg",
        mobile: "/images/mobile1.png",
    },
    {
        desktop: "/images/water.png",
        mobile: "/images/mobile2.png",
    },
    {
        desktop: "/images/water.png",
        mobile: "/images/mobile2.png",
    },
];

export default function TopBanner() {
    return (
    <div className="relative isolate h-[85dvh] w-full overflow-hidden lg:h-screen">
        {/* BACKGROUND SLIDER */}
        <div className="absolute inset-0 z-0">
            <Swiper
                modules={[Autoplay, EffectFade]}
                effect="fade"
                fadeEffect={{ crossFade: true }}
                loop={SLIDES.length > 1}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                allowTouchMove={false}
                className="h-full w-full"
            >
                {SLIDES.map((slide, i) => (
                    <SwiperSlide
                        key={i}
                        className="relative h-full w-full"
                    >
                        <picture className="absolute inset-0 block h-full w-full">
                            <source
                                media="(max-width: 1023px)"
                                srcSet={slide.mobile}
                            />

                            <Image
                                src={slide.desktop}
                                alt="Mobetts Agro Centre equipment"
                                fill
                                priority={i === 0}
                                sizes="100vw"
                                className="object-cover object-center"
                            />
                        </picture>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>

        {/* CONTENT */}
        <div
            className={`absolute inset-0 z-50 flex items-end pt-16 pb-10 lg:pt-28 lg:pb-15 3xl:pb-25 ${GRID_CLASSES}`}
        >
            <div className="col-span-6 flex flex-col items-start text-white">
                <h1 className="max-w-[17ch] text-[clamp(2.65rem,9vw,6.5rem)] font-semibold leading-[0.98] tracking-[-0.03em] lg:max-w-4xl">
                    Your partner
                    <br className="lg:hidden" />
                    {" "}for{" "}
                    <span className="text-orange-200">
                        reliable equipment
                    </span>
                </h1>

                <p className="mt-4 max-w-[36ch] text-sm leading-5 lg:mt-8 lg:text-lg lg:leading-7">
                    We provide reliable equipment, honest advice, and dependable
                    support—from choosing the right product to keeping it running
                    long after the sale.
                </p>

                <div className="mt-4 flex w-fit gap-3 text-xs lg:mt-6 lg:gap-4 lg:text-base">
                    <Link
                        href="/our-services"
                        className="inline-flex shrink-0 items-center justify-center gap-2 bg-orange-200 px-3 py-2 text-sm text-black lg:gap-3 lg:px-4 lg:py-4"
                    >
                        Explore solutions
                        <ArrowRight className="h-4 w-4 shrink-0 -rotate-45" />
                    </Link>

                    <Link
                        href="/shop"
                        className="inline-flex shrink-0 items-center justify-center gap-2 bg-white px-3 py-2 text-sm text-black lg:gap-3 lg:px-4 lg:py-4"
                    >
                        Shop products
                        <ArrowRight className="h-4 w-4 shrink-0 -rotate-45" />
                    </Link>
                </div>
            </div>
        </div>
    </div>
);
}